import type { SVGProps } from "react";

export const MathToolkit = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Math toolkit</title>
    <path
      d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm6 5H9V6H7v2H5v2h2v2h2V10h2V8Zm7 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm-3 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM5 16.5h7v-2H5v2Z"
      fill="currentColor"
    />
  </svg>
);

export default MathToolkit;
